module.exports = {"domain":"pdview.au.auth0.com","clientID":"RoHq4vE04WH8JE6zYYWTS6rLggue7iA2","audience":"https://pdview.au.auth0.com/userinfo","responseType":"token id_token","scope":"openid profile email","prompt":"none"}


//////////////////
// WEBPACK FOOTER
// ./src/config/auth0.json
// module id = 1089
// module chunks = 0